(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nuwaria-nav-branch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nuwaria-nav-branch')) {
    class NuwariaNavBranch extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.toggle = this.querySelector(':scope > .nuwaria-nav-branch__row > button');
        this.panel = this.querySelector(':scope > .nuwaria-nav-branch__panel');
        if (!this.toggle || !this.panel) return;
        this.toggle.addEventListener('click', () => this.setOpen(this.panel.hidden), options);
        this.addEventListener('pointerenter', (event) => {
          if (this.dataset.mode === 'desktop' && event.pointerType !== 'touch') {
            clearTimeout(this.closeTimer); this.setOpen(true);
          }
        }, options);
        this.addEventListener('pointerleave', () => {
          if (this.dataset.mode === 'desktop') this.closeTimer = setTimeout(() => this.setOpen(false), 160);
        }, options);
        this.addEventListener('focusin', () => clearTimeout(this.closeTimer), options);
        this.addEventListener('focusout', (event) => {
          if (this.dataset.mode === 'desktop' && !this.contains(event.relatedTarget)) this.setOpen(false);
        }, options);
        this.addEventListener('keydown', (event) => this.onKey(event), options);
        document.addEventListener('pointerdown', (event) => {
          if (this.dataset.mode === 'desktop' && !this.contains(event.target)) this.setOpen(false);
        }, options);
      }
      disconnectedCallback() { clearTimeout(this.closeTimer); this.controller?.abort(); }
      setOpen(open, focusToggle = false) {
        clearTimeout(this.closeTimer);
        this.panel.hidden = !open;
        this.toggle.setAttribute('aria-expanded', String(open));
        this.toggle.setAttribute('aria-label', `${open ? 'Collapse' : 'Expand'} ${this.querySelector(':scope > .nuwaria-nav-branch__row > a').textContent.trim()}`);
        this.toggleAttribute('data-open', open);
        if (open && this.dataset.mode === 'desktop') {
          for (const sibling of this.parentElement.children) {
            if (sibling !== this && sibling.matches('nuwaria-nav-branch')) sibling.setOpen(false);
          }
        }
        if (!open) this.panel.querySelectorAll('nuwaria-nav-branch').forEach((child) => child.setOpen(false));
        if (focusToggle) this.toggle.focus();
      }
      onKey(event) {
        if (event.target.closest('nuwaria-nav-branch') !== this) return;
        const inPanel = this.panel.contains(event.target);
        if ((event.key === 'ArrowRight' || event.key === 'ArrowDown') && !inPanel) {
          event.preventDefault(); event.stopPropagation(); this.setOpen(true);
          this.panel.querySelector('a,button')?.focus();
        } else if ((event.key === 'Escape' || event.key === 'ArrowLeft') && !this.panel.hidden) {
          event.preventDefault(); event.stopPropagation(); this.setOpen(false, true);
        } else if (event.key === 'Escape' && this.dataset.mode === 'desktop') {
          event.preventDefault(); event.stopPropagation();
          const item = this.closest('.menu-list__list-item');
          item?.querySelector(':scope > .menu-list__link')?.focus();
          this.closest('header-menu')?.deactivate(event);
        } else if (inPanel && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          const links = [...this.panel.querySelectorAll('a')].filter((link) => link.closest('nuwaria-nav-branch') === this);
          const index = links.indexOf(event.target);
          if (index < 0) return;
          event.preventDefault(); event.stopPropagation();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links[next]?.focus();
        }
      }
    }
    customElements.define('nuwaria-nav-branch', NuwariaNavBranch);
  }
  } catch(e) { console.error(e); }
})();

})();
